module.exports = __webpack_public_path__ + "img/sCrazyMnky_350x350.7387f827.jpg";